var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"netto-bidding-summary"},[_c('span',{staticClass:"netto-bidding-summary__text"},[_vm._v("Dein Gebot")]),_vm._v(" "),_c('span',{staticClass:"netto-bidding-summary__value"},[_vm._v(_vm._s(_vm.bidFormatted))])])
}
var staticRenderFns = []

export { render, staticRenderFns }